import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogInput } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    DateTableColumn,
    NumberTableColumn,
    TableColumn,
    TextTableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import {
    Behandlungsraum,
    HeimtierBehandlungsraumDialogComponent,
} from './heimtier-behandlungsraum-dialog/heimtier-behandlungsraum-dialog.component';

@Component({
    selector: 'kiene-heimtier-behandlungs-raeume',
    templateUrl: './heimtier-behandlungs-raeume.component.html',
    styleUrls: ['./heimtier-behandlungs-raeume.component.scss'],
})
export class HeimtierBehandlungsRaeumeComponent implements OnInit {
    tableDescriptor = new TableDescriptor();

    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private tableService: KieneTableService,
        private messageService: MessageService,
        private dialog: MatDialog,
        private api: KieneBackendApiService,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Behandlungsräume';
        this.tableDescriptor.uniqueIdentifier = 'Behandlungsräume';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'behandlungsraum/';

        const columns: TableColumn[] = [];

        columns.push(new NumberTableColumn('behandlungsraum_id', 'ID', '1.0-0'));
        columns.push(new TextTableColumn('name', 'Raumname'));
        columns.push(new TableColumn('raum_nr', 'Raumnummer'));
        columns.push(new TextTableColumn('kunde', 'Belegt durch:'));
        columns.push(new DateTableColumn('editiert', 'Editiert'));
        this.tableDescriptor.columns = columns;

        this.tableDescriptor.initialSortColumn = 'raum_nr';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.defaultPageSize = 10;

        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDownloads = false;
        this.tableDescriptor.sendCurrentClient = true;
        this.tableDescriptor.showDetailsVoid = this.openBehandlungsraumDialog.bind(this);

        this.tableDescriptor.permissionView = 7007;
        this.tableDescriptor.permissionCreate = 7008;

        this.tableDescriptor.options = this.getOptions();
        this.tableDescriptor.toolbarButtons = this.getToolbarButtons();
        this.tableDescriptor.addVoid = this.openBehandlungsraumDialog.bind(this);
    }

    getOptions(): TableOption[] {
        const options: TableOption[] = [];
        options.push(new TableOption(this.openBehandlungsraumDialog.bind(this), 'Editieren', 'edit', 7008));
        options.push(new TableOption(this.deleteRaum.bind(this), 'Löschen', 'delete', 7009));
        return options;
    }

    private getToolbarButtons(): ToolbarButton[] {
        const toolbarButtons = [];
        return toolbarButtons;
    }

    private openBehandlungsraumDialog(value?: Behandlungsraum): void {
        if (!value) {
            value = new Behandlungsraum();
        }
        this.dialog
            .open(HeimtierBehandlungsraumDialogComponent, { data: value })
            .afterClosed()
            .subscribe({
                next: () => {
                    this.tableService.reload();
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Speichern des raumes!', err);
                },
            });
    }

    private deleteRaum(value: any): void {
        const input = new ConfirmDialogInput();
        input.headline = 'Raum löschen';
        input.text = 'Möchten Sie den Raum wirklich löschen?';
        input.okButton = 'Löschen';

        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result?.ok && result?.confirmed) {
                        this.api.deleteEntity(this.apiBaseUrl + 'behandlungsraum/delete.php', value).subscribe({
                            next: () => {
                                this.tableService.reload();
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim Löschen des raumes!', err);
                            },
                        });
                    }
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Löschen des raumes!', err);
                },
            });
    }
}
